module.exports = __webpack_public_path__ + "img/dash-card-block-1.5d5f8625.svg";